export default [
  {
    width: 9,
    header: {
      type: 'text',
      caption: 'Id',
    },
    cell: {
      type: 'slot',
      name: 'id',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Status',
    },
    cell: {
      type: 'slot',
      name: 'status',
    },
  },
  {
    width: 20,
    header: {
      sort: 'CreatedAt',
      type: 'text',
      caption: 'Started / Ended',
    },
    cell: {
      type: 'slot',
      name: 'startedEnded',
    },
  },
  {
    width: 40,
    header: {
      type: 'text',
      caption: 'Seller',
    },
    cell: {
      type: 'slot',
      name: 'seller',
    },
  },
  {
    width: 40,
    header: {
      type: 'text',
      caption: 'Buyer',
    },
    cell: {
      type: 'slot',
      name: 'buyer',
    },
  },
];
